module.exports = __webpack_public_path__ + "static/shop-catalog-7cde34b623d08bf67644193170499a9a.jpg";